import moment from 'moment'
import uuid from 'uuid/v4'

export const EventValues = [
  {
    id: uuid(),
    lot: '',
    startDate: new Date(),
    endDate: new Date(),
    section: '',
    fullValue: '0,00',
    clubValue: '0,00'
  }
]

export const ListDate = [
  {
    id: uuid(),
    startDate: new Date(),
    endDate: new Date(),
    time: new Date()
  }
]

export const ParserListDate = list => {
  return list.map(item => {
    return {
      startDate: moment(item.startDate).format('YYYY-MM-DD'),
      endDate: moment(item.endDate).format('YYYY-MM-DD'),
      time: moment(item.time).format('HH:mm')
    }
  })
}

export const ParserListDateInvert = list => {
  return list.map(item => {
    return {
      ...item,
      startDate: moment(item.startDate).toDate(),
      endDate: moment(item.endDate).toDate(),
      time: moment(item.time, 'HH:mm:ss').toDate()
    }
  })
}

export const ParserEventsPricing = list => {
  return list.map(item => {
    return {
      ...item,
      startDate: moment(item.startDate).format('YYYY-MM-DD'),
      endDate: moment(item.endDate).format('YYYY-MM-DD')
    }
  })
}

export const ParserEventsPricingInvert = list => {
  return list.map(item => {
    return {
      ...item,
      startDate: moment(item.startDate, 'YYYY-MM-DD').toDate(),
      endDate: moment(item.endDate, 'YYYY-MM-DD').toDate()
    }
  })
}

export const ParserPartnerCodesItensInvert = list =>
  list.map(item => {
    return {
      uuid: item.id,
      value: item.value,
      startDate: moment(item.startDate, 'YYYY-MM-DD').toDate(),
      endDate: moment(item.endDate, 'YYYY-MM-DD').toDate()
    }
  })

export const ParserPartnerCodesItens = list => {
  return list.map(item => {
    return {
      ...item,
      startDate: moment(item.startDate).format('YYYY-MM-DD'),
      endDate: moment(item.endDate).format('YYYY-MM-DD')
    }
  })
}
